export interface HardCodedUnit {
    replacement: string;
    similarities: string[]
}

//

// usage example: {replacement: "a", similarities: ["à", "á", "â", "ä", "ã", "å", "ā", "ą", "æ"]},
export const HardCoded: HardCodedUnit[] = [
    {"replacement":"_","similarities":["˷","˽","▂"]},
    {"replacement":"-","similarities":["ꟷ","〜","¬","֊","ᅩ","ᅳ","—","⌢","─","━","╾","▪","ー", "⸺"]},
    {"replacement":";","similarities":["⁏"]},
    {"replacement":":","similarities":["⠃","⠌","⠰","⡈","⁝"]},
    {"replacement":"!","similarities":["❗","❗️","❣","⣛"]},
    {"replacement":"?","similarities":["¿","؟"]},
    {"replacement":".","similarities":["⬝","∙","⦁","᛫","‧","⸳","ꞏ","·","ˑ","˯","˳","•","⋅","⠄","⠐","⠠","⡀","⢀","⸱","。","・","｡"]},
    {"replacement":",","similarities":["､","܉","⸴","ܝ","¸","ˏ","˒","˓","˔","ˬ","˰","˱","˲","˻","˼","˿","⢄","⢠","⢤","⣄","⣠","、"]},
    {"replacement":"'","similarities":["៸","˙","˹","˺","⠁","⠈","⠊","⠋","⠘","⠙"]},
    {"replacement":"\"","similarities":["˵","˶","”","„"]},
    {"replacement":"(","similarities":["【"]},
    {"replacement":")","similarities":["】"]},
    {"replacement":"[","similarities":["⦏"]},
    {"replacement":"]","similarities":["⦎"]},
    {"replacement":"*","similarities":["҉","※","☀","☆","⛥","✩","✮","✱"]},
    {"replacement":"/","similarities":["༼"]},
    {"replacement":"\\","similarities":["༽"]},
    {"replacement":"%","similarities":["÷"]},
    {"replacement":"^","similarities":["ᄉ","ᄌ"]},
    {"replacement":"<","similarities":["ᗒ","〈","《"]},
    {"replacement":"=","similarities":["˭","═","ニ"]},
    {"replacement":">","similarities":["ᗕ","〉","》"]},
    {"replacement":"|","similarities":["৷","⏐","¦","ᅡ","ᅣ","ᅥ","ᅵ","╎","⠇","⠸","⡆","⡇","⢰","⢸","⋮","︴"]},
    {"replacement":"$","similarities":["💲","ֆ"]},
    {"replacement":"0","similarities":["0️⃣","0⃣","⓿","🄌","⓪","🄋","θ","ᆷ","᱐","囗"]},
    {"replacement":"1","similarities":["1️⃣","1⃣","❶","➊","①","➀"]},
    {"replacement":"2","similarities":["2️⃣","2⃣","❷","➋","②","➁","ƨ","ᄅ","ᆯ","己"]},
    {"replacement":"3","similarities":["3️⃣","3⃣","❸","➌","③","➂","Э","з","э","ℨ","ꝫ"]},
    {"replacement":"4","similarities":["4️⃣","4⃣","❹","➍","④","➃"]},
    {"replacement":"5","similarities":["5️⃣","5⃣","❺","➎","⑤","➄","ƽ","⣫","丂"]},
    {"replacement":"6","similarities":["6️⃣","6⃣","❻","➏","⑥","➅"]},
    {"replacement":"7","similarities":["7️⃣","7⃣","❼","➐","⑦","➆","ク","タ","ワ"]},
    {"replacement":"8","similarities":["8️⃣","8⃣","❽","➑","⑧","➇","⽇"]},
    {"replacement":"9","similarities":["9️⃣","9⃣","❾","➒","⑨","➈","⣻"]},
    {"replacement":"a","similarities":["ᴀ","ᶏ","⍶","▴","ꬰ","▲"]},
    {"replacement":"A","similarities":["⩜","ᗋ","🇦","Δ","Λ","λ","д","ค","Ꭿ","ᗩ","₳","人","𐌀","🅰","🅰️"]},
    {"replacement":"b","similarities":["ƀ","ƃ","ɓ","ʙ","Ъ","в","ъ","ь","ᴃ","ᵬ","ᶀ","ⲃ","ち"]},
    {"replacement":"B","similarities":["ß","Ɓ","Ƀ","฿","፪","Ⲃ","乃","🅱️"]},
    {"replacement":"c","similarities":["¢","©","ƈ","ɕ","ς","ϲ","ᄃ","￠"]},
    {"replacement":"C","similarities":["Ƈ","ʗ","Ϲ","ር","Ꮳ","ᑕ","₵","⊂","匚","Ꞓ","🅲"]},
    {"replacement":"d","similarities":["đ","ȡ","ɖ","ɗ","Ԁ","ᴅ","ᵭ","ᶁ","ᶑ"]},
    {"replacement":"D","similarities":["⫐","🇩","Ð","Đ","Ɗ"]},
    {"replacement":"e","similarities":["ɐ","ⴒ","ǝ","ə","ᶒ","ⱸ"]},
    {"replacement":"E","similarities":["∈","🇪","£","Ǝ","Ɛ","ɛ","Ξ","έ","ε","ϵ","Є","є","ع","ᗴ","ᙓ","ᴇ","ᶓ","€","∍","≋","ⲉ","乇","𐌄"]},
    {"replacement":"f","similarities":["ƒ","ғ","ᶂ","ꜰ"]},
    {"replacement":"F","similarities":["Ƒ","Ꝼ"]},
    {"replacement":"g","similarities":["ᏽ","ǥ","ɠ","ɢ"]},
    {"replacement":"G","similarities":["Ᏽ","🇬","Ɠ","Ǥ","₲"]},
    {"replacement":"h","similarities":["ħ","ɦ","ʜ","ⱨ","ん"]},
    {"replacement":"H","similarities":["ӊ","н","ᅢ","Ⱨ"]},
    {"replacement":"i","similarities":["¡","ɨ","ᶖ","⫯","ⲓ","ꪱ"]},
    {"replacement":"I","similarities":["Ɨ","І","Ї","工"]},
    {"replacement":"j","similarities":["ȷ","ɉ","ɟ","ʝ","د","ر","ᴊ","⡸","⣨"]},
    {"replacement":"J","similarities":["ᒙ","Ɉ","ك","ᓚ","╯","⣼","丁"]},
    {"replacement":"k","similarities":["ƙ","κ","к","ќ","ҝ","ҟ","ӄ","ᴋ","ᶄ","ⱪ","ⲕ","ꝁ","ꝃ","ꝅ"]},
    {"replacement":"K","similarities":["Ƙ","Ҝ","₭","Ⱪ","Ꝁ","Ꝃ"]},
    {"replacement":"l","similarities":["ᶩ","ɭ","𐑊","ŀ","ł","ƚ","ȴ","ɫ","ɬ","ɭ","ʟ","ᥣ","ᴌ","ᶅ","╰","❙","❚","ⱡ","ꝉ","ꞁ"]},
    {"replacement":"L","similarities":["լ","┗","ட","ᒷ","𐑃","Ŀ","Ł","Ƚ","Լ","ᄂ","ᆫ","∟","└","⠧","⠼","⣆","⣇","⣧","⣸","Ⱡ","Ɫ","し","ㄥ","Ꝇ","Ꝉ","𐌋","🇱","ᒺ"]},
    {"replacement":"m","similarities":["⫙","ӎ","ɱ","м","๓","ᴍ","ᵯ","ᶆ","₥"]},
    {"replacement":"M","similarities":["𐊿","ϻ","Ӎ","ᙏ","ʍ","ᛗ","Ɱ","ꮇ","𐊎","𐌼","🇲"]},
    {"replacement":"n","similarities":["ŉ","ŋ","ƞ","ȵ","ɲ","ɳ","ɴ","ή","η","π","и","л","п","ղ","ภ","ᵰ","ᶇ","ᾔ","ⲛ"]},
    {"replacement":"N","similarities":["Ɲ","Ƞ","П","ຖ","ᘉ","₦","ﬡ"]},
    {"replacement":"o","similarities":["🇴","ʘ","°","ð","ø","ǿ","ɵ","́","δ","҈","࿁","ᄆ","ᄋ","∘","◦","▫","◎","●","◕","⚈","❍","ⱺ","ロ","ꝋ","ꝍ"]},
    {"replacement":"O","similarities":["Ø","Ɵ","Ǿ","⭘","◯","Ꝋ","Ꝍ","𑄶"]},
    {"replacement":"p","similarities":["℗","þ","ƥ","ƿ","ҏ","ք","ᴘ","ᵱ","ᵽ","ᶈ","⠟","ꝑ","ꝓ","ꝕ"]},
    {"replacement":"P","similarities":["Ⴒ","ᑷ","ᖘ","Þ","Ƥ","Ƿ","Ҏ","ק","م","ᑬ","ᕵ","ᖰ","‽","₱","℘","⡟","⡿","Ᵽ","卩","尸","Ꝑ","Ꝓ","Ꝕ","🅿️","🇵"]},
    {"replacement":"q","similarities":["¶","ɋ","ᶐ","ꝗ","ꟼ"]},
    {"replacement":"r","similarities":["®","ſ","ɍ","ɼ","ɽ","ɾ","ʀ","Г","ѓ","ґ","፫","ᵲ","ᵳ","ᶉ","ẛ","⠏","⡏","ꞅ"]},
    {"replacement":"R","similarities":["Ɍ","Я","я","Ɽ","尺","🇷"]},
    {"replacement":"s","similarities":["ȿ","ʂ","ي","ᵴ","ᶊ","⸉"]},
    {"replacement":"S","similarities":["§","క","ട","Ⴝ","⟆","𐌔","🆂"]},
    {"replacement":"t","similarities":["ŧ","ƫ","ƭ","ȶ","ʈ","τ","т","է","ᖶ","ᴛ","ᵵ","†","✝","ⲧ","テ"]},
    {"replacement":"T","similarities":["┬","⏉","ፐ","🇹","Ŧ","Ƭ","Ʈ","Ͳ","ͳ","፰","₮","╤","╦","☂","〒","す"]},
    {"replacement":"u","similarities":["ʊ","ц","մ","ت","ن","ย","ᥙ","ᴗ","ᵾ"]},
    {"replacement":"U","similarities":["ப","꒤","Ʉ","Ա","น","፱","ᑘ","ᘎ","⋓","🇺"]},
    {"replacement":"v","similarities":["ⱱ","ⱴ"]},
    {"replacement":"V","similarities":["∇","✓","✔","✔️"]},
    {"replacement":"w","similarities":["ω","ⱳ"]},
    {"replacement":"W","similarities":["Щ","ш","щ","₩","Ⱳ","ꟽ"]},
    {"replacement":"x","similarities":["ж","ჯ","ᶍ"]},
    {"replacement":"X","similarities":["Ӽ","乂"]},
    {"replacement":"y","similarities":["⑂","ⴤ","ƴ","ɏ"]},
    {"replacement":"Y","similarities":["ߌ","¥","Ƴ","Ɏ","Ў","Ỿ"]},
    {"replacement":"z","similarities":["🇿","ƶ","ȥ","ɀ","ʐ","ʑ","ᵶ","ᶎ","ⱬ","ⲍ"]},
    {"replacement":"Z","similarities":["Ƶ","Ȥ","Ⴭ","፯","☡","Ⱬ","Ɀ","Ⲍ","乙"]},
    {"replacement":"->","similarities":["→","⟶"]},
    {"replacement":"=>","similarities":["⟹"]},
    {"replacement":", ","similarities":["、"]},
    {"replacement":"::","similarities":["⣒"]},
    {"replacement":":.","similarities":["⣁"]},
    {"replacement":"..","similarities":["⠤","⣀"]},
    {"replacement":"''","similarities":["⠉"]},
    {"replacement":"/\\","similarities":["ハ"]},
    {"replacement":"<-","similarities":["←"]},
    {"replacement":"=)","similarities":["シ","ッ"]},
    {"replacement":"---","similarities":["⸻"]},
    {"replacement":"AB","similarities":["🆎"]},
    {"replacement":"bl","similarities":["ы"]},
    {"replacement":"cl","similarities":["디"]},
    {"replacement":"CL","similarities":["🆑"]},
    {"replacement":"COOL","similarities":["🆒"]},
    {"replacement":"FREE","similarities":["🆓"]},
    {"replacement":"ID","similarities":["🆔"]},
    {"replacement":"ij","similarities":["⺉","リ"]},
    {"replacement":"io","similarities":["ю"]},
    {"replacement":"lt","similarities":["け"]},
    {"replacement":"NEW","similarities":["🆕"]},
    {"replacement":"NG","similarities":["🆖"]},
    {"replacement":"OK","similarities":["🆗"]},
    {"replacement":"RU","similarities":["🇷🇺"]},
    {"replacement":"SOS","similarities":["🆘"]},
    {"replacement":"UP!","similarities":["🆙"]},
    {"replacement":"VS","similarities":["🆚"]},
];

//

const HardCodedMap: Map<string, string> = (() => {
    const map = new Map<string, string>();

    for (const unit of HardCoded) {
        for (const similiarity of unit.similarities)
            map.set(similiarity, unit.replacement);
    }

    return map;
})();

export default HardCodedMap;